import React, {Component} from "react";
import Header from "../../../Containers/Header/Header";
import Footer from "../../../Containers/Footer";
import AdminManagementClassroom from "./Classroom";
import AdminManagementHomework from "./Homework";
import AdminManagementStudent from "./Student";

import Cookies from "universal-cookie";
import Base64 from "base-64";

class AdminManagement extends Component {
    /*state = {
     tabList: [
     {id: 0, text: "학급 관리", checked: true},
     {id: 1, text: "학생 관리", checked: false},
     {id: 2, text: "숙제 관리", checked: false}
     ],
     tabIndex: 0
     }*/

    constructor() {
        super();
        if (this.getIdentityFromCookie() === 'I_TEACHER') {
            this.state = {
                tabList: [
                    {id: 0, text: "숙제 관리", checked: true}
                ],
                tabIndex: 0
            };
        } else {
            this.state = {
                tabList: [
                    {id: 0, text: "학급 관리", checked: true},
                    {id: 1, text: "학생 관리", checked: false},
                    {id: 2, text: "숙제 관리", checked: false}
                ],
                tabIndex: 0
            };
        }
    }

    getIdentityFromCookie = () => {
        const cookies = new Cookies();
        if (cookies.get('beacon_token') != null && !cookies.get('beacon_token').isEmpty) {
            // cookie 값에서 signature 뺌
            const beaconToken = cookies.get('beacon_token').split('.')[1];
            if (beaconToken != null && !beaconToken.isEmpty) {
                // decode cookie
                const decodedCookie = JSON.parse(Base64.decode(beaconToken));
                if (decodedCookie != null && !decodedCookie.isEmpty) {
                    const identity = decodedCookie['jti'];
                    return identity;
                }
            }
        }
        return null;
    }

    setTabButton = () => {
        const {tabList} = this.state;
        return (
            <div className="list-btn">
                {tabList.map(
                    ({id, text, checked}) => (
                        <a key={id} className={(checked) ? "active" : ""}
                           onClick={() => this.onClickTabButton(id)}>{text}</a>
                    )
                )}
            </div>
        );
    }

    onClickTabButton = (id) => {
        const {tabList} = this.state;
        const index = tabList.findIndex(item => item.id === id);
        const changeList = [...tabList];
        changeList.map((item) => item.checked = (item.id === index));
        this.setState({
            tabList: changeList,
            tabIndex: index
        });
    }

    render() {
        let displayContent;
        if (this.getIdentityFromCookie() === 'I_TEACHER') {
            displayContent = <AdminManagementHomework/>
        } else {
            displayContent = (this.state.tabIndex === 2) ? <AdminManagementHomework/> :
                (this.state.tabIndex === 1) ? <AdminManagementStudent/> : <AdminManagementClassroom/>;
        }

        return (
            <div className="beaconWrapper">
                <Header selectedIndex={1}/>
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                        <div className="adminWrapper">
                            {this.setTabButton()}
                            <div className="wrap-rCon">
                                {displayContent}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default AdminManagement;



// WEBPACK FOOTER //
// ./src/components/Pages/Teacher/AdminManagement/index.js